import { get } from "./api";
import { Geojson } from "../Map/types";
import { Config } from "../../Config";

export const fetchSchemeShapefile = async (options?: RequestInit): Promise<Geojson> => {
    return get<Geojson>(`${Config.mapApi}/public/scheme_location.geojson`, options);
};
